import { MainComponent } from './components/main/main.component';
import { LoginComponent } from './components/login/login.component';
import { AuthGuardService} from './core/guards/auth-guard';
import { UnauthGuardService} from './core/guards/unauth-guard';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import {ResetPasswordComponent} from './components/reset-password/reset-password.component';
import {UpdatePlanComponent} from './components/update-plan/update-plan.component';
import {PlanExpirationGuard} from './core/guards/plan-expiration-guard';

export const appRoutes = [
  { path: '', component: MainComponent, canActivate: [AuthGuardService, PlanExpirationGuard]},
  { path: 'login', component: LoginComponent, canActivate: [UnauthGuardService] },
  { path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [UnauthGuardService] },
  { path: 'reset-password/:token', component: ResetPasswordComponent, canActivate: [UnauthGuardService] },
  { path: 'update-plan', component: UpdatePlanComponent, canActivate: [AuthGuardService]},
  { path: '**',  pathMatch: 'full', redirectTo: ''}
];



// WEBPACK FOOTER //
// ./client/app/app.routes.ts